const websiteTypes = {
  FETCH_WEBSITES_START: 'FETCH_WEBSITES_START',
  FETCH_WEBSITES_START_SUCCESS: 'FETCH_WEBSITES_START_SUCCESS',
  FETCH_WEBSITES_START_FAILURE: 'FETCH_WEBSITES_START_FAILURE',
  ADD_NEW_CONTAINER_START: 'ADD_NEW_CONTAINER_START',
  ADD_NEW_WEBSITE_START: 'ADD_NEW_WEBSITE_START',
  TOGGLE_WEBSITE_STATUS_START: 'TOGGLE_WEBSITE_STATUS_START',
  ASSIGN_OPERATORS_START: 'ASSIGN_OPERATORS_START',
  LOADING_WEBSITES: 'LOADING_WEBSITES',
  SET_WEBSITES: 'SET_WEBSITES',
  ADD_NEW_WEBSITE: 'ADD_NEW_WEBSITE',
  SET_WEBSITE_STATUS: 'SET_WEBSITE_STATUS',
  SET_CURRENT_WEBSITE: 'SET_CURRENT_WEBSITE',
  UPDATE_WEBSITE_OPERATOR_LIST: 'UPDATE_WEBSITE_OPERATOR_LIST',
  FETCH_WHATSAPP_BARCODE_START: 'FETCH_WHATSAPP_BARCODE_START',
  LOADING_WHATSAPP_BARCODE: 'LOADING_WHATSAPP_BARCODE',
  SET_WHATSAPP_BARCODE: 'SET_WHATSAPP_BARCODE',
  LOGOUT_WHATSAPP: 'LOGOUT_WHATSAPP',
  SET_PERMISSION_WHATSAPP: 'SET_PERMISSION_WHATSAPP',
  UPDATE_CONTAINER_TEAM: 'UPDATE_CONTAINER_TEAM',
  SEND_CONTAINERS_TEAM: 'SEND_CONTAINERS_TEAM',
  SET_CHANNELS_TEAM: 'SET_CHANNELS_TEAM',
  SET_AGENT_ASSIGN_BY_URL: 'SET_AGENT_ASSIGN_BY_URL',
  SEND_GROUP_MESSAGE: 'SEND_GROUP_MESSAGE',
  SEND_WHATSAPP_GROUP_MESSAGE: 'SEND_WHATSAPP_GROUP_MESSAGE',
  DELETE_WEBSITE: 'DELETE_WEBSITE',
  DELETE_WEBSITE_SUCCESS: 'DELETE_WEBSITE_SUCCESS',
  DELETE_WEBSITE_FAILURE: 'DELETE_WEBSITE_FAILURE',
  SET_SELECTED_WORKSPACE: 'SET_SELECTED_WORKSPACE',
  RESET_WEBSITES_STATE: 'RESET_WEBSITES_STATE',
};

export default websiteTypes;
